import React from "react";
// node.js library that concatenates classes (strings)
import classnames from "classnames";
// javascipt plugin for creating charts
import Chart from "chart.js";
// react plugin used to create charts
import {Bar, Line} from "react-chartjs-2";
import {RotateCircleLoading} from 'react-loadingg';
// core components
import {chartExample1, chartExample2, chartOptions, parseOptions} from "variables/charts.js";

import Header from "../components/Headers/Header.js";
import {Redirect} from "react-router-dom";

import {
    Button,
    Card,
    CardBody,
    CardHeader,
    Col,
    Container, Modal,
    Nav,
    NavItem,
    NavLink,
    Row,
} from "reactstrap";
import DayPreview from "../components/Schedule/DayPreview";
import reportApiService from "../api/report-api-service";
import ErrorModal from "../components/Alerts/ErrorModal";
import AddOneClassModal from "../components/Schedule/AddOneClassModal";
import businessApiService from "../api/business-api-service";
import localeHelpers from "../helpers/LocaleHelper";
import LocalizedStrings from "react-localization";
import {common_strings} from "../translations/common_translations";
import {student_strings} from "../translations/student_translations";
import {resource_strings} from "../translations/resource_translations";
import {alert_strings} from "../translations/alert_translations";
import {report_strings} from "../translations/report_translations";
import NotificationComponent from "../components/NotificationComponent";
import constants from "../shared/constants";
import EditEventModal from "../components/Schedule/EditEventModal";
import businessHelper from "../helpers/BusinessHelper";
import lsHelpers from "../helpers/LsHelper";
import WelcomeModal from "../components/Alerts/WelcomeModal";
import dateHelpers from "../helpers/DateHelper";
import stripeSvg from "assets/img/icons/common/stripe.svg"
import PaymentModal from "../components/PaymentModal";
import resourceApiService from "../api/resource-api-service";
import HeaderAlert from "../components/Alerts/SuccessAlert";

let commonStrings = new LocalizedStrings(common_strings);
let studentStrings = new LocalizedStrings(student_strings);
let resourceStrings = new LocalizedStrings(resource_strings);
let alertStrings = new LocalizedStrings(alert_strings);
let reportStrings = new LocalizedStrings(report_strings);

class Index extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            subUser: businessHelper.subUser(),
            attendance_loading: false,
            activeNav: 1,
            todayDate: new Date(),
            events: null,
            dayShift: 0,
            refreshDayView: false,
            statsType: "week",
            currency: "$",
            chartData: chartExample1["test_data"],
            salesData: chartExample2["ticket_sales_data"],
            showError: false,
            error: null,
            showClassEditor: false,
            notifications_loading: false,
            notifications: null,
            goToClient: false,
            goToClientId: null,
            selectedReport: null,
            goToSchedule: false,
            showNotificationModal: false,
            showEventModal: false,
            showPaymentModal: false,
            selectedEvent: null,
            toLandingPage: false,
            goToProfile: false,
            updatingUser: false,
            show_no_attendance_data: false,
            showVerifiedModal: false,
            showWelcomeModal: lsHelpers.mustShowWelcome(),
            goToClients: false,
            goToEditTicketType: false,
            showStripeSuccessModal: false,
            showPaymentSuccess: false,
            shouldShowCashierBanner: false,
            shouldShowUkraineBanner: false,
        };
        if (window.Chart) {
            parseOptions(Chart, chartOptions());
        }
    }

    goToClass = this.goToClass.bind(this);
    openEvent = this.openEvent.bind(this);
    getAttendanceStats = this.getAttendanceStats.bind(this);
    toggleErrorModal = this.toggleErrorModal.bind(this);
    closeEditClassView = this.closeEditClassView.bind(this);
    toggleOneClassModal = this.toggleOneClassModal.bind(this);
    editClassAction = this.editClassAction.bind(this);
    onNotificationSelected = this.onNotificationSelected.bind(this);
    showNotificationModal = this.showNotificationModal.bind(this);
    handleEventSaved = this.handleEventSaved.bind(this);
    renderRequestPaymentBanner = this.renderRequestPaymentBanner.bind(this);

    toggleErrorModal() {
        this.setState({error: null, showError: false})
    }

    getAttendanceStats(type = this.state.statsType) {
        this.setState({attendance_loading: true});
        reportApiService.attendanceStats(type)
            .then(res => {
                this.setState({
                    show_no_attendance_data: (res.data.labels === null || res.data.labels.length === 0),
                    attendance_loading: false,
                    isLoading: false,
                    chartData: res.data,
                });
            })
            .catch((e) => {
                this.handleNetworkError(e)
            });

    }

    getNotifications() {
        this.setState({notifications_loading: true});
        businessApiService.notifications()
            .then(res => {
                this.setState({
                    notifications_loading: false,
                });
                this.generateNotificationData(res)
            })
            .catch((e) => {
                this.handleNetworkError(e)
            });

    }

    handleNetworkError(e) {
        this.setState({
            isLoading: false,
            error: e,
            showError: true,
            attendance_loading: false,
        });
    }

    getTicketSales() {
        if (!businessHelper.isTeacherSession()) {
            this.setState({isLoading: true});
            reportApiService.ticketSales()
                .then(res => {
                    this.setState({
                        salesData: res.sales,
                        currency: res.currency,
                    });

                    this.setState({isLoading: false})
                })
                .catch((e) => {
                    this.setState({
                        error: e,
                        showError: true
                    });
                });
        }
    }

    componentDidMount() {
        lsHelpers.updateWeekScheduleShift(0);
        localStorage.scheduleView = "week";

        if (!localStorage.getItem('at') || !localStorage.getItem('business')) {
            return <Redirect from="*" to="/auth/login"/>
        } else {
            this.getAttendanceStats();
            this.getNotifications();
            this.getTicketSales();
            this.checkStripeLink();

            this.getUser()
        }
    }

    checkStripeLink() {
        const query = new URLSearchParams(this.props.location.search);
        const code = query.get('code');
        const subscriptionCreationSuccess = query.get('scs');
        const subscriptionCreationError = query.get('sce');

        if (subscriptionCreationSuccess) {
            this.togglePaymentSuccessModal()
            return
        }

        if (code && code.length > 1) this.postSCode(code)
    }

    postSCode(code) {
        this.setState({isLoading: true});
        businessApiService.connectStripe(code)
            .then(res => {
                this.getUser();
                this.setState({showStripeSuccessModal: true})
            })
            .catch((e) => {
                this.handleNetworkError(e)
            });
    }

    toggleStripeSuccessModal = state => {
        this.setState({
            showStripeSuccessModal: !this.state.showStripeSuccessModal
        });
    };

    togglePaymentSuccessModal(modal) {
        this.setState({showPaymentSuccess: !this.state.showPaymentSuccess})
    }

    renderPaymentSuccessModal() {
        return (<Modal
            className="modal-dialog-centered modal-success"
            contentClassName="bg-gradient-success"
            isOpen={this.state.showPaymentSuccess}
            toggle={() => this.togglePaymentSuccessModal("notificationModal")}
        >
            <div className="modal-header">
                <h6 className="modal-title" id="modal-title-notification">
                    {/*Your attention is required*/}
                </h6>
                <button
                    aria-label="Close"
                    className="close"
                    data-dismiss="modal"
                    type="button"
                    onClick={() => this.togglePaymentSuccessModal("notificationModal")}
                >
                    <span aria-hidden={true}>×</span>
                </button>
            </div>
            <div className="modal-body">
                <div className="py-3 text-center">
                    <img
                        alt="..."
                        width={100}
                        height={"auto"}
                        src={require("assets/img/brand/open-white-logo.png")}/>
                    <h4 className="heading mt-4">{alertStrings.success}</h4>
                    <p className="mt-4">
                        {resourceStrings.subscriptions.payment_success}
                    </p>
                </div>
            </div>
            <div className="modal-footer">
                <Button
                    className="text-white ml-auto"
                    color="link"
                    data-dismiss="modal"
                    type="button"
                    onClick={() => this.togglePaymentSuccessModal("notificationModal")}
                >
                    {commonStrings.close}
                </Button>
            </div>
        </Modal>)
    }

    renderStripeSuccessModal() {
        return (<Modal
            className="modal-dialog-centered modal-success"
            contentClassName="bg-gradient-success"
            isOpen={this.state.showStripeSuccessModal}
            toggle={() => this.toggleStripeSuccessModal("notificationModal")}
        >
            <div className="modal-header">
                <h6 className="modal-title" id="modal-title-notification">
                    {/*Your attention is required*/}
                </h6>
                <button
                    aria-label="Close"
                    className="close"
                    data-dismiss="modal"
                    type="button"
                    onClick={() => this.toggleStripeSuccessModal("notificationModal")}
                >
                    <span aria-hidden={true}>×</span>
                </button>
            </div>
            <div className="modal-body">
                <div className="py-3 text-center">
                    <img
                        alt="..."
                        width={64}
                        height={64}
                        src={stripeSvg}/>
                    <h4 className="heading mt-4">{alertStrings.success}</h4>
                    <p>
                        {alertStrings.success_stripe}
                    </p>
                </div>
            </div>
            <div className="modal-footer">
                <Button
                    className="text-white ml-auto"
                    color="link"
                    data-dismiss="modal"
                    type="button"
                    onClick={() => this.toggleStripeSuccessModal("notificationModal")}
                >
                    {commonStrings.close}
                </Button>

                <Button
                    color="link"
                    data-dismiss="modal"
                    type="button"
                    onClick={(e) => this.continueTicketTypeCreation(e)}
                >
                    {commonStrings.continue}
                </Button>
            </div>
        </Modal>)
    }

    continueTicketTypeCreation(e) {
        e.preventDefault();
        this.setState({goToEditTicketType: true})
    }

    toggleNavs = (e, index) => {
        e.preventDefault();
        this.setState({
            activeNav: index
        });

        this.getAttendanceStats(index === 1 ? "month" : "week")
    };

    onNotificationSelected(e, item) {
        switch (item.type) {
            case "bd":
                this.goToStudent(item.id);
                break;
            case "notification_exp_tickets":
                this.goToExpTicketReport();
                break;
            case "booking":
                if (item.yclass_id) {
                    this.goToClass(item.yclass_id)
                } else return
                break;
            case "unbooking":
                if (item.yclass_id) {
                    this.goToClass(item.yclass_id)
                } else return
                break;
            case "new_client":
                if (item.student_id) {
                    this.goToStudent(item.student_id)
                } else return
                break;
            case "wix_new_ticket":
                this.goToStudent(item.student_id);
                break;
            case "student_message":
                this.goToStudent(item.student_id);
                break;
            case "stripe_new_ticket":
                this.goToStudent(item.student_id);
                break;
            case "wix_new_student":
                this.goToStudent(item.student_id);
                break;
            case "feedback":
                this.goToClass(item.yclass_id);
                break;
            default:
                this.goToSchedule();
                break;
        }
    }

    toggleEventModal() {
        this.setState({showEventModal: !this.state.showEventModal})
    }

    helpUkraineLink() {
        resourceApiService.donationInrst()
        window.open(`https://clx.by/pivnichniy-kharkiv?fbclid=PAAaZdgbbb3uVybQOrAXvVLIEgOZbc2ozA1sCUSIT2y5p-ev3hLlG6WFiPrD4`, "_blank")
    }

    togglePaymentModal() {
        if (!this.state.showPaymentModal) {
            resourceApiService.paymentLinkRequest()
        }

        this.setState({showPaymentModal: !this.state.showPaymentModal})
    }

    renderUkraineBanner() {
        return (<Card className="shadow mb-4" style={{cursor: 'pointer'}}
                      onClick={this.helpUkraineLink.bind(this)}>

            <CardHeader className="sborder-0" onClick={e => this.toggleUkraineBanner()}>
                <div style={{display: "flex", flexFlow: "row", justifyContent: "space-between", alignItems: "center"}}>

                    <h3 className="mb-0 text-black">{alertStrings.ukraine_header}</h3>

                    <div>
                        <Button
                            color="white"
                            onClick={this.helpUkraineLink.bind(this)}
                            size="sm"
                        >
                            {alertStrings.ukraine_button}
                        </Button>
                    </div>
                </div>
            </CardHeader>

            {this.state.shouldShowUkraineBanner &&

                <CardBody className="text-center">

                    <label style={{
                        color: 'text-black',
                        width: "100%",
                        padding: 20,
                        fontWeight: 600,
                        textAlign: "center",
                        marginTop: -10,
                    }}>{alertStrings.ukraine_body}</label>

                    <label style={{
                        color: 'text-black',
                        width: "100%",
                        padding: 20,
                        fontWeight: 500,
                        textAlign: "center",
                        marginTop: -10,
                    }}>{alertStrings.ukraine_body_2}</label>

                    <img
                        alt="..."
                        width={80}
                        height={"auto"}
                        src={require("assets/img/brand/ukraine.png")}/>
                </CardBody>
            }

        </Card>)
    }

    copyReferralCode() {
        navigator.clipboard.writeText(businessHelper.business().referral_code)
        resourceApiService.referralInrst()

        this.setState({alertData: {
                type: 'success',
                text: `${alertStrings.referral_copy_success}`
            }})
    }

    renderReferralBanner() {
        return (<Card className="bg-gradient-success mb-4" style={{cursor: 'pointer'}}
                      onClick={this.copyReferralCode.bind(this)}>

            <CardHeader className="bg-gradient-success border-0">
                <div style={{display: "flex", flexFlow: "row", justifyContent: "center", alignItems: "center"}}>

                    <div>
                        <h3 className="mb-0" style={{color: "#ffffff"}}>{alertStrings.referral_title.toUpperCase()}</h3>
                    </div>
                </div>
            </CardHeader>

            <CardBody className="text-center">

                <label style={{
                    color: 'white',
                    width: "100%",
                    padding: 20,
                    fontWeight: 600,
                    textAlign: "center",
                    marginTop: -10,
                }}>{alertStrings.referral_body}</label>

                <label style={{
                    color: 'white',
                    width: "100%",
                    padding: 20,
                    cursor: 'pointer',
                    fontSize: "2rem",
                    fontWeight: 800,
                    textAlign: "center",
                    marginTop: -10,
                }}>{businessHelper.business().referral_code}</label>

                <label style={{
                    color: 'white',
                    width: "100%",
                    padding: 20,
                    fontWeight: 500,
                    textAlign: "center",
                    marginTop: -10,
                }}>{alertStrings.referral_expl}</label>

                <img
                    alt="..."
                    width={80}
                    height={"auto"}
                    src={require("assets/img/brand/customer.png")}/>
            </CardBody>

        </Card>)
    }

    toggleCashierBanner() {
        this.setState({shouldShowCashierBanner: !this.state.shouldShowCashierBanner})
    }

    toggleUkraineBanner() {
        this.setState({shouldShowUkraineBanner: !this.state.shouldShowUkraineBanner})
    }

    renderRequestPaymentBanner() {
        return (<Card className="bg-gradient-default mb-2" style={{cursor: 'pointer'}}
                      onClick={this.togglePaymentModal.bind(this)}>

            <CardHeader className="bg-gradient-default border-0" onClick={e => this.toggleCashierBanner(e)}>
                <div style={{display: "flex", flexFlow: "row", justifyContent: "space-between", alignItems: "center"}}>
                    <div>
                        <div style={{display: "flex", flexFlow: "row"}}>
                            <h3 className="text-white mb-0">{businessHelper.currency() + " "}{resourceStrings.payment.request_payment + " "}</h3>
                        </div>
                    </div>

                    <div>
                        <Button
                            color="primary"
                            onClick={this.togglePaymentModal.bind(this)}
                            size="sm"
                        >
                            {commonStrings.try_now}
                        </Button>
                    </div>
                </div>
            </CardHeader>

            {this.state.shouldShowCashierBanner &&

                <CardBody className="text-center">
                    <img
                        alt="..."
                        width={80}
                        height={"auto"}
                        src={require("assets/img/brand/security-white.png")}/>

                    <label style={{
                        color: 'white',
                        width: "100%",
                        fontWeight: 700,
                        textAlign: "center",
                        marginTop: 20,
                    }}>{resourceStrings.payment.request_payment_expl}</label>
                </CardBody>
            }

        </Card>)
    }

    render() {
        this.localize();

        if (this.state.goToClient === true) {
            return <Redirect from="*" to={{
                pathname: "/admin/student-profile",
                state: {
                    clientId: this.state.goToClientId
                }
            }}/>
        }

        if (this.state.goToClass === true && this.state.goToClassId) {
            return <Redirect from="*" to={{
                pathname: "/admin/class_overview",
                state: {yclassId: this.state.goToClassId}
            }}/>
        }

        if (this.state.selectedReport !== null) {
            return <Redirect from="*" to={{
                pathname: "/admin/tables",
                state: {reportName: this.state.selectedReport, reportDates: this.state.reportDates}
            }}/>
        }

        if (this.state.goToClients === true) {
            return <Redirect from="*" to={{
                pathname: "/admin/clients",
                state: {filters: {newOnly: true, groups: null}}
            }}/>
        }

        if (this.state.goToSchedule === true) {
            return <Redirect from="*" to={{
                pathname: "/admin/schedule",
            }}/>
        }

        if (this.state.goToProfile === true) {
            return <Redirect from="*" to={{
                pathname: "/admin/user-profile",
            }}/>
        }

        if (this.state.goToEditTicketType == true) {
            return <Redirect from="*" to={{
                pathname: "/admin/user-profile",
                state: {goToEditTicketType: true}
            }}/>
        }

        if (!localStorage.getItem('at') || !localStorage.getItem('business')) {
            return <Redirect from="*" to="/auth/login"/>
        }

        // if (this.state.toLandingPage === true) {
        //     return <Redirect from="*" to="/landing"/>
        // }

        return (
            <>
                <Header
                    goToTicketReport={this.goToTicketReport.bind(this)}
                    goToClients={this.goToClients.bind(this)}
                />
                {/* Page content */}
                <Container className="mt--7" fluid>

                    {this.state.alertData &&
                        <HeaderAlert alertData={this.state.alertData}/>
                    }

                    {this.state.showStripeSuccessModal === true &&
                        this.renderStripeSuccessModal()
                    }

                    {this.state.showPaymentSuccess === true &&
                        this.renderPaymentSuccessModal()
                    }

                    {this.state.showNotificationModal === true &&
                        this.renderNotificationModal()
                    }

                    {this.state.showClassEditor === true &&
                        this.renderAddClassPopup()
                    }

                    {this.state.showWelcomeModal === true &&
                        this.renderWelcomeModal()
                    }

                    {this.state.showError && <ErrorModal showError={this.state.showError} error={this.state.error}
                                                         toggleErrorModal={this.toggleErrorModal}/>}

                    {this.state.showEventModal === true &&
                        <EditEventModal toggleModal={() => this.toggleEventModal()} event={this.state.selectedEvent}
                                        handleEventSaved={this.handleEventSaved}
                                        handleError={() => this.handleNetworkError}
                        />
                    }

                    {this.state.showPaymentModal === true &&
                        <PaymentModal toggleModal={() => this.togglePaymentModal()}
                                      handleError={() => this.handleNetworkError}
                        />
                    }

                    <Row className="mt-5">

                        <Col className="mb-5 mb-xl-0 bg-transparent mx-0" xl="8">
                            {/*<Schedule/>*/}
                            <DayPreview shift={0}
                                        goToClass={this.goToClass}
                                        date={new Date()}
                                        openEvent={this.openEvent}
                                        updateDayPreview={this.state.updateDayPreview}
                                        addClass={this.editClassAction}
                                        subUser={this.state.subUser}
                            />
                        </Col>

                        <Col xl="4">
                            {this.renderNotificationComponent()}
                            {this.renderReferralBanner()}
                            {this.renderUkraineBanner()}
                            {this.renderRequestPaymentBanner()}
                        </Col>
                        {/*}*/}
                    </Row>
                    <Row>
                        <Col className="mb-5 mt-5 mb-xl-0" xl="8">
                            <Card className="bg-gradient-default shadow">
                                <CardHeader className="bg-transparent">
                                    {this.state.attendance_loading &&
                                        <RotateCircleLoading color="white"/>
                                    }
                                    <Row className="align-items-center">
                                        <div className="col">
                                            <h6 className="text-uppercase text-light ls-1 mb-1">
                                                {reportStrings.overview}
                                            </h6>
                                            <h2 className="text-white mb-0">{reportStrings.attendance}</h2>
                                        </div>
                                        <div className="col">
                                            <Nav className="justify-content-end" pills>
                                                <NavItem>
                                                    <NavLink
                                                        className={classnames("py-2 px-3", {
                                                            active: this.state.activeNav === 1
                                                        })}
                                                        data-toggle="tab"
                                                        href="#pablo"
                                                        onClick={e => this.toggleNavs(e, 2)}
                                                    >
                                                        <span className="d-none d-md-block">{commonStrings.week}</span>
                                                        <span
                                                            className="d-md-none">{commonStrings.week.charAt(0)}</span>
                                                    </NavLink>
                                                </NavItem>
                                                <NavItem>
                                                    <NavLink
                                                        className={classnames("py-2 px-3", {
                                                            active: this.state.activeNav === 2
                                                        })}
                                                        href="#pablo"
                                                        onClick={e => this.toggleNavs(e, 1)
                                                        }
                                                    >
                                                        <span className="d-none d-md-block">{commonStrings.month}</span>
                                                        <span
                                                            className="d-md-none">{commonStrings.month.charAt(0)}</span>
                                                    </NavLink>
                                                </NavItem>
                                            </Nav>
                                        </div>
                                    </Row>
                                </CardHeader>
                                <CardBody>
                                    {/* Chart */}
                                    <div className="chart">
                                        {this.showNoAttendanceLabel() &&
                                            <div className="text-center"
                                                 style={{height: "100%", width: "100%", verticalAlign: "middle"}}>
                                            <span className="text-center"
                                                  style={{width: "100%", position: 'relative', top: '50%'}}>
                                                {reportStrings.no_attendance_data}
                                            </span></div>
                                        }
                                        {!this.showNoAttendanceLabel() && !businessHelper.isTeacherSession() &&
                                            <Line
                                                data={this.state.chartData}
                                                options={chartExample1.options}
                                                getDatasetAtEvent={e => console.log(e)}
                                            />
                                        }
                                    </div>
                                </CardBody>
                            </Card>
                        </Col>
                        <Col className="mt-5" xl="4">
                            <Card className="shadow">
                                <CardHeader className="bg-transparent">
                                    <Row className="align-items-center">
                                        <div className="col">
                                            <h6 className="text-uppercase text-muted ls-1 mb-1">
                                                {reportStrings.sales}
                                            </h6>
                                            <h2 className="mb-0">{reportStrings.ticket_sales} {this.state.currency}</h2>
                                        </div>
                                    </Row>
                                </CardHeader>
                                <CardBody>
                                    {/* Chart */}
                                    {!businessHelper.isTeacherSession() &&
                                        <div className="chart">
                                            <Bar
                                                cur={"J"}
                                                data={this.state.salesData}
                                                options={chartExample2.options}
                                            />
                                        </div>
                                    }
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                    {/*<sch/>*/}
                </Container>
            </>
        );
    }

    goToClass(id, from) {
        this.setState({goToClass: true, goToClassId: id})
    }

    openEvent(event) {
        this.setState({showEventModal: true, selectedEvent: event})
    }

    toggleOneClassModal() {
        this.setState({showClassEditor: !this.state.showClassEditor})
    }

    closeEditClassView(e) {
        if (e) {
            e.preventDefault()
        }

        this.setState({showClassEditor: false, updateDayPreview: true});
    }

    renderAddClassPopup() {
        return <AddOneClassModal
            closeEditClassView={this.closeEditClassView}
            goToProfile={this.goToProfile.bind(this)}
            showEditClassType={false}
            toggleModal={this.toggleOneClassModal}
            handleError={this.handleNetworkError}
            date={this.state.addClassForDate}
        />
    }

    goToProfile(e) {
        e.preventDefault();
        this.setState({goToProfile: true})
    }

    editClassAction(e, date) {
        if (e) {
            e.preventDefault()
        }

        let d = new Date()
        try {
            d = new Date(date)
        } catch (e) {
            console.log(e.message)
        }

        this.setState({
            showClassEditor: true,
            addClassForDate: d,
        })
    }

    generateNotificationData(data) {
        const result = [];
        if (data.expiring_tickets === true) result.push({
            title: reportStrings.expiring_tickets_report,
            type: "notification_exp_tickets"
        });
        if (data.s_bd && data.s_bd.length > 0) {
            data.s_bd.forEach(d => result.push({title: d.name, type: "bd", id: d.id}))
        }
        if (data.events && data.events.length > 0) {
            data.events.forEach(d => result.push({title: d.title, body: d.body, type: "event"}))
        }
        if (data.tasks && data.tasks.length > 0) {
            data.tasks.forEach(d => result.push({title: d.title, body: d.body, type: "task"}))
        }
        if (data.notifications && data.notifications.length > 0) {
            data.notifications.forEach(n => result.push({
                title: this.notificationTitle(n),
                type: n.n_type,
                yclass_id: n.class_id,
                student_id: n.student_id
            }))
        }

        this.setState({notifications: result})
    }

    localize() {
        const loc = localeHelpers.currentLocale();
        commonStrings.setLanguage(loc);
        studentStrings.setLanguage(loc);
        resourceStrings.setLanguage(loc);
        reportStrings.setLanguage(loc);
        alertStrings.setLanguage(loc);
    }

    goToStudent(id) {
        this.setState({
            goToClient: true,
            goToClientId: id,
        });
    }

    goToExpTicketReport() {
        this.setState(prevState => ({
            selectedReport: constants.reports.expiringTickets,
        }));
    }

    goToTicketReport(e) {
        e.preventDefault();

        this.setState(prevState => ({
            selectedReport: constants.reports.ticketReport,
            reportDates: dateHelpers.curWeekStartEnd()
        }));
    }

    goToClients(e) {
        e.preventDefault();

        this.setState(prevState => ({
            goToClients: true,
        }));
    }

    goToSchedule() {
        this.setState(prevState => ({
            goToSchedule: true,
        }));
    }

    toggleShowNotificationModal = state => {
        this.setState({
            showNotificationModal: !this.state.showNotificationModal
        });
    };

    showNotificationModal() {
        this.setState({showNotificationModal: true})
    }

    renderNotificationModal() {
        return <Modal
            className="modal-dialog-centered modal-danger"
            contentClassName="bg-gradient-warning"
            size="lg"
            isOpen={this.state.showNotificationModal}
            toggle={() => this.toggleShowNotificationModal("notificationModal")}
        >
            <div className="modal-header">
                <h6 className="modal-title" id="modal-title-notification">
                    {/*Your attention is required*/}
                </h6>
                <button
                    aria-label="Close"
                    className="close"
                    data-dismiss="modal"
                    type="button"
                    onClick={() => this.toggleShowNotificationModal("notificationModal")}
                >
                    <span aria-hidden={true}>×</span>
                </button>
            </div>
            <div className="modal-body text-gray">
                <NotificationComponent items={(this.state.notifications)}
                                       onNotificationSelected={this.onNotificationSelected}/>
            </div>
        </Modal>
    }

    handleEventSaved() {
        this.setState({showEventModal: false, updateDayPreview: true});
    }

    showNoAttendanceLabel() {
        return (this.state.show_no_attendance_data === true)
    }

    toggleWelcomeModal() {
        this.setState({showWelcomeModal: !this.state.showWelcomeModal})
    }

    renderWelcomeModal() {
        return <WelcomeModal toggleWelcomeModal={this.toggleWelcomeModal.bind(this)}
                             showWelcomeModal={this.state.showWelcomeModal}
                             toProfile={this.goToProfile.bind(this)}
        />
    }

    notificationTitle(n) {
        if (n.n_type === "booking") {
            if (n.data.student_name && n.data.yclass_name) {
                return commonStrings.formatString(commonStrings.notifications.booking_title, n.data.student_name, n.data.yclass_name)
            } else return ""
        } else if (n.n_type === "unbooking") {
            if (n.data.student_name && n.data.yclass_name) {
                return commonStrings.formatString(commonStrings.notifications.unbooking_title, n.data.student_name, n.data.yclass_name)
            } else return ""
        } else if (n.n_type === "new_client") {
            if (n.data.student_name) {
                return commonStrings.formatString(commonStrings.notifications.new_client_title, n.data.student_name)
            } else return ""
        } else if (n.n_type === "wix_new_student") {
            if (n.data.student_name) {
                return commonStrings.formatString(commonStrings.notifications.new_client_title, n.data.student_name)
            } else return ""
        } else if (n.n_type === "wix_new_ticket") {
            if (n.data.student_name) {
                return commonStrings.formatString(commonStrings.notifications.new_wix_ticket_title, n.data.student_name + ", " + n.data.ticket_name)
            } else return ""
        } else if (n.n_type === "stripe_new_ticket") {
            if (n.data.student_name) {
                return commonStrings.formatString(commonStrings.notifications.new_stripe_ticket_title, n.data.student_name + ", " + n.data.ticket_name)
            } else return ""
        } else if (n.n_type === "feedback") {
            if (n.data.yclass_name) {
                return commonStrings.formatString(commonStrings.notifications.new_feedback, n.data.yclass_name)
            } else return ""}
        else if (n.n_type === "student_message") {
            if (n.data.student_name) {
                return commonStrings.formatString(commonStrings.notifications.message_title, n.data.student_name)
            } else return ""
        } else return ""

    }

    getUser() {
        businessApiService.current()
            .then(res => {
                businessHelper.saveUserSession(res);
            })
            .catch((e) => {
                console.log(e.toString())
            });
    }

    renderNotificationComponent() {
        return <NotificationComponent items={(this.state.notifications || []).slice(0, 7)}
                               onNotificationSelected={this.onNotificationSelected}
                               seeAll={this.showNotificationModal}
                               totalNotifications={this.state.notifications ? this.state.notifications.length : 0}
        />
    }
}

export default Index;
